
		import { Buffer } from 'buffer'
		if (window.global === undefined) { window.global = window; window.Buffer = Buffer }
	